function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo, useCallback, useEffect, forwardRef } from 'react';
import { nanoid } from 'nanoid';
import { assertIsDashboardPluginProps, LayoutUtils, canHaveRef, usePanelOpenListener } from '@deephaven/dashboard';
import Log from '@deephaven/log';
import { createChainedComponent, createChainedPanelComponent, usePlugins } from '@deephaven/plugin';
import { WidgetPanel } from "./panels/index.js";
import { getSupportedWidgetTypes, getUniqueWidgetPluginInfos } from "./WidgetLoaderUtils.js";
import { jsx as _jsx } from "react/jsx-runtime";
var log = Log.module('WidgetLoaderPlugin');
export function WrapWidgetPlugin(plugin) {
  var _plugin$component$dis;
  function Wrapper(props, ref) {
    var _metadata$type, _metadata$name;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var C = plugin.component;
    var metadata = props.metadata;
    var panelDescriptor = _objectSpread(_objectSpread({}, metadata), {}, {
      type: (_metadata$type = metadata === null || metadata === void 0 ? void 0 : metadata.type) !== null && _metadata$type !== void 0 ? _metadata$type : plugin.type,
      name: (_metadata$name = metadata === null || metadata === void 0 ? void 0 : metadata.name) !== null && _metadata$name !== void 0 ? _metadata$name : 'Widget'
    });
    var hasRef = canHaveRef(C);
    var className = "widget-loader-".concat(panelDescriptor.type);
    return /*#__PURE__*/_jsx(WidgetPanel, _objectSpread(_objectSpread({
      descriptor: panelDescriptor,
      className: className
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, props), {}, {
      children: hasRef ? /*#__PURE__*/_jsx(C
      // eslint-disable-next-line react/jsx-props-no-spreading
      , _objectSpread(_objectSpread({}, props), {}, {
        ref: ref
      })) : /*#__PURE__*/_jsx(C
      // eslint-disable-next-line react/jsx-props-no-spreading
      , _objectSpread({}, props))
    }));
  }
  Wrapper.displayName = "WidgetLoaderPlugin(".concat((_plugin$component$dis = plugin.component.displayName) !== null && _plugin$component$dis !== void 0 ? _plugin$component$dis : plugin.name, ")");
  return /*#__PURE__*/forwardRef(Wrapper);
}

/**
 * Widget to automatically open any supported WidgetPlugin types as panels
 * if the widget is emitted from the server as the result of executed code.
 *
 * Does not open panels for widgets that are not supported by any plugins.
 * Does not open panels for widgets that are a component of a larger widget or UI element.
 *
 * Supports plugin chaining via middleware plugins. When multiple plugins
 * support the same widget type, middleware plugins are chained around
 * the base plugin in registration order.
 *
 * @param props Dashboard plugin props
 * @returns React element
 */
export function WidgetLoaderPlugin(props) {
  var plugins = usePlugins();
  var supportedTypes = useMemo(() => getSupportedWidgetTypes(plugins), [plugins]);
  assertIsDashboardPluginProps(props);
  var id = props.id,
    layout = props.layout,
    registerComponent = props.registerComponent;
  var handlePanelOpen = useCallback(_ref => {
    var _widget$name;
    var dragEvent = _ref.dragEvent,
      _ref$panelId = _ref.panelId,
      panelId = _ref$panelId === void 0 ? nanoid() : _ref$panelId,
      fetch = _ref.fetch,
      widget = _ref.widget;
    var type = widget.type;
    var typeInfo = type != null ? supportedTypes.get(type) : null;
    if (typeInfo == null) {
      return;
    }
    var name = (_widget$name = widget.name) !== null && _widget$name !== void 0 ? _widget$name : type;
    var panelProps = {
      localDashboardId: id,
      metadata: widget,
      fetch
    };
    var config = {
      type: 'react-component',
      component: typeInfo.basePlugin.name,
      props: panelProps,
      title: name,
      id: panelId
    };
    var root = layout.root;
    LayoutUtils.openComponent({
      root,
      config,
      dragEvent
    });
  }, [id, layout, supportedTypes]);
  useEffect(() => {
    // Get unique base plugins (a plugin may handle multiple types)
    var uniquePluginInfos = getUniqueWidgetPluginInfos(supportedTypes);
    log.debug('Registering widget components', [...uniquePluginInfos.entries()].map(_ref2 => {
      var _ref3 = _slicedToArray(_ref2, 2),
        name = _ref3[0],
        info = _ref3[1];
      return {
        plugin: name,
        middleware: info.middleware.map(m => m.name),
        hasPanel: info.basePlugin.panelComponent != null
      };
    }));
    var deregisterFns = [...uniquePluginInfos.values()].map(_ref4 => {
      var basePlugin = _ref4.basePlugin,
        middleware = _ref4.middleware;
      var panelComponent = basePlugin.panelComponent;
      if (panelComponent == null) {
        // No panel component - chain the widget components and wrap in default panel
        log.debug("Chaining widget components for ".concat(basePlugin.name, " (no panel component, using default wrapper)"));
        var chainedComponent = createChainedComponent(basePlugin.component, middleware);
        var wrappedPlugin = _objectSpread(_objectSpread({}, basePlugin), {}, {
          component: chainedComponent
        });
        return registerComponent(basePlugin.name, WrapWidgetPlugin(wrappedPlugin));
      }

      // Has panel component - chain middleware around the panel.
      // Only middleware that defines panelComponent is applied here.
      // Middleware with only component is skipped in this path.
      log.debug("Chaining panel components for ".concat(basePlugin.name, " (has custom panel component)"));
      var chainedPanelComponent = createChainedPanelComponent(panelComponent, middleware);
      return registerComponent(basePlugin.name, chainedPanelComponent);
    });
    return () => {
      deregisterFns.forEach(deregister => deregister());
    };
  }, [registerComponent, supportedTypes]);

  /**
   * Listen for panel open events so we know when to open a panel
   */
  usePanelOpenListener(layout.eventHub, handlePanelOpen);
  return null;
}
export default WidgetLoaderPlugin;
//# sourceMappingURL=WidgetLoaderPlugin.js.map